module.exports = __webpack_public_path__ + "src/assets/textures/env/shovel/shovel_512_bake.png";